export const isValidUrl = (url: string): boolean => {
  try {
    return Boolean(new URL(url));
  } catch {
    return false;
  }
};

export const isUrlHttps = (url: string): boolean =>
  url.split(':')[0] === 'https';
